import { getLanguage } from '../utils/locale';
import serverApi, { serverApiWithAuth } from './index';

export const fetchQuestionnaire = id => serverApi.get(`/votes/${id}`, { params: { language: getLanguage() } });
export const fetchElection = id => serverApi.get(`/elections/${id}`, { params: { language: getLanguage() } });
export const fetchQuestionnaires = () => serverApi.get('/login', { params: { language: getLanguage() } });

export const sendElectionAnswersRequest = async (electionId, districtId, answers) => {
  const body = {
    answers: Object.keys(answers).map(questionId => ({
      questionId,
      answer: answers[questionId]
    }))
  };
  return serverApi.post(`/elections/${electionId}/districts/${districtId}/calculate-results`, body, {
    params: { language: await getLanguage() }
  });
};


export const saveQuestionnairesResults = (questionnaireId, content) => {
  try {
    const data = {
      votingProposalSurveyResult: {
        votingProposal: questionnaireId,
        content
      }
    };

    return serverApi.post('/survey', data);
  } catch (e) {
    console.error(e);
    throw e.data;
  }
};

export const getQuestionnairesResults = () => {
  try {
    return serverApiWithAuth.get('/survey', { params: { language: getLanguage() } });
  } catch (e) {
    console.log(e);
    throw e.data;
  }
};
